/*eslint-disable react/no-danger*/

import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import bbcode from 'bitter-bbcode';
import { emojify } from 'react-emojione';

import ResourceCommentsList from 'containers/ResourceCommentsList';
import Button from 'components/Button';
import { getMagazineArticle } from 'selectors';
import { MagazineArticleShape } from 'entities';
import './style.scss';
import * as actions from 'actions';
import { actionCausedByURLChangeFrom } from 'utils/actions';
import queries from 'magazineQueries';
import MagazineArticlesSidebar from 'containers/MagazineArticlesSidebar';
import MagazineArticle from 'containers/MagazineArticle';
import EmptyArticle from 'components/EmptyArticle';
import ResourceCommentsTextEditor from 'containers/ResourceCommentsTextEditor';
import { findCommentRepliesType } from 'commentsResourceTypes';

class MagazineArticleProfile extends Component {

  constructor() {
    super();

    this.handleFollow = this.handleFollow.bind(this);
    this.handleUnfollow = this.handleUnfollow.bind(this);
    this.handleFavourite = this.handleFavourite.bind(this);
    this.handleUnfavourite = this.handleUnfavourite.bind(this);
    this.scrolledToComments = false;
    this.defaultArticle = {thumbnail: { main: {highRes: null} }};
  }

  componentDidMount() {
    if(this.props.onDidMount) {
      this.props.onDidMount();
    }
  }

  componentDidUpdate(prevProps) {
    if(this.props.magazineArticle.text &&
       this.props.location.hash === '#comments' &&
       !this.scrolledToComments) {
      this.scrolledToComments = true;
      const textEditorElement = ReactDOM.findDOMNode(this.refs.textEditor);
      window.scrollTo(0, textEditorElement.offsetTop - this.refs.magazineArticleProfile.offsetTop);
    }

    this.props.onDidUpdate && this.props.onDidUpdate(prevProps.params);
  }

  handleFollow() {
    this.props.onFollow && this.props.onFollow(this.props.magazineArticle);
  }

  handleUnfollow() {
    this.props.onFollow && this.props.onUnfollow(this.props.magazineArticle);
  }

  handleFavourite(event) {
    event.preventDefault();
    this.props.onFavourite && this.props.onFavourite(this.props.magazineArticle);
  }

  handleUnfavourite(event) {
    event.preventDefault();
    this.props.onUnfavourite && this.props.onUnfavourite(this.props.magazineArticle);
  }

  render() {
    const { magazineArticle = this.defaultArticle } = this.props;
    const html = magazineArticle.text ? bbcode(magazineArticle.text) : null;

    return (
      <div className="MagazineArticleProfile" ref="magazineArticleProfile">
        <div className="wrapper-xlarge is-collapsed">
          {(() => {
            if(magazineArticle.id) {
              return (
                <MagazineArticle
                  magazineArticle={magazineArticle}
                  imageUrl={magazineArticle.thumbnail.preview.highRes}
                  isTitleOnTop={true}
                  showsReadMoreAndComments={false}
                  isFeatured
                  />
              );
            }
            else {
              return <EmptyArticle isFeatured />;
            }
          })()}
        </div>

        <div className="wrapper-large is-collapsed">
          <div className="community-resource">
            {(() => {
              if(html) {
                return <div className="resource-text-content" dangerouslySetInnerHTML={{__html: emojify(html, {output: 'unicode'})}} />;
              }

              return (
                <div className="while-loading">
                  <h3>{__('members.magazine.loading')}</h3>
                </div>
              );
            })()}

            <div className="resource-actions">
              <div className="favourites-button float-left">
                {(() => {
                  if(magazineArticle.favourite) {
                    return <Button isSmall isYellow hasIcon iconType="star" onClick={this.handleUnfavourite}>{__('members.magazine.addToFavourites')}</Button>;
                  }

                  return <Button isSmall hasIcon iconType="star" onClick={this.handleFavourite}>{__('members.magazine.removeFromFavourites')}</Button>;
                })()}
              </div>

              <div className="resource-add-comment">
                <ResourceCommentsTextEditor ref="textEditor" isForNewComments resourceType="articles" resourceId={magazineArticle.id} />
              </div>

              {magazineArticle.id &&
                <ResourceCommentsList
                  scrollElementGetter={() => this.refs.magazineArticleProfile}
                  urlParams={this.props.params}
                  isFollowed={magazineArticle.followed}
                  resourceId={magazineArticle.id}
                  canCommentsBeRepliedTo={true}
                  resourceType="articles"
                  repliesResourceType={findCommentRepliesType('articles')}
                  onFollow={this.handleFollow}
                  onUnfollow={this.handleUnfollow}
                  />
              }
            </div>
          </div>

          <MagazineArticlesSidebar queries={{['Popular']: queries['Popular']}} isWider />
        </div>
      </div>
    );
  }
}

MagazineArticleProfile.propTypes = {
  magazineArticle: MagazineArticleShape,
  location: PropTypes.object,
  params: PropTypes.object,
  onResourceFollow: PropTypes.func,
  onDidMount: PropTypes.func,
  onFollow: PropTypes.func,
  onUnfollow: PropTypes.func,
  onFavourite: PropTypes.func,
  onUnfavourite: PropTypes.func,
  onDidUpdate: PropTypes.func
};

const mapStateToProps = (state, props) => {
	return {
    magazineArticle: getMagazineArticle(state, props.params.id)
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    onDidMount: () => {
      dispatch(actionCausedByURLChangeFrom(actions.magazineArticleProfileFetch(props.params.id)));
    },
    onDidUpdate: prevParams => {
      if(prevParams.id !== props.params.id) {
        dispatch(actionCausedByURLChangeFrom(actions.magazineArticleProfileFetch(props.params.id)));
      }
    },
    onFollow: magazineArticle => {
      dispatch(actions.magazineArticleUpdate(magazineArticle.id, magazineArticle, {followed: true}));
    },
    onUnfollow: magazineArticle => {
      dispatch(actions.magazineArticleUpdate(magazineArticle.id, magazineArticle, {followed: false}));
    },
    onFavourite: magazineArticle => {
      dispatch(actions.magazineArticleUpdate(magazineArticle.id, magazineArticle, {favourite: true}));
    },
    onUnfavourite: magazineArticle => {
      dispatch(actions.magazineArticleUpdate(magazineArticle.id, magazineArticle, {favourite: false}));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MagazineArticleProfile);



/** WEBPACK FOOTER **
 ** ./src/members/Main/Magazine/MagazineArticleProfile/index.js
 **/